/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { ContentAiGetContentQueryResponse, ContentAiGetContentPathParams, ContentAiGetContent401, ContentAiGetContent403 } from "../models/ContentAiGetContent";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { contentAiGetContent } from "../axios/contentAiGetContent";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const contentAiGetContentQueryKey = (id: ContentAiGetContentPathParams["id"]) => ["api-v2", { url: '/content-ai/v1/contents/:id', params: {id:id} }] as const

export type ContentAiGetContentQueryKey = ReturnType<typeof contentAiGetContentQueryKey>

export function contentAiGetContentQueryOptions(id: ContentAiGetContentPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = contentAiGetContentQueryKey(id)
        return queryOptions<ContentAiGetContentQueryResponse, ResponseErrorConfig<ContentAiGetContent401 | ContentAiGetContent403>, ContentAiGetContentQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return contentAiGetContent(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get content by ID
 * {@link /content-ai/v1/contents/:id}
 */
export function useContentAiGetContent<TData = ContentAiGetContentQueryResponse, TQueryData = ContentAiGetContentQueryResponse, TQueryKey extends QueryKey = ContentAiGetContentQueryKey>(id: ContentAiGetContentPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<ContentAiGetContentQueryResponse, ResponseErrorConfig<ContentAiGetContent401 | ContentAiGetContent403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? contentAiGetContentQueryKey(id)
         

         const query = useQuery({
          ...contentAiGetContentQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ContentAiGetContent401 | ContentAiGetContent403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}